export default {
  metadata: {
    version: '1.0.0',
    id: 'link-1.0.0',
    name: 'JDSLink'
  },
  hierarchy: {
    container: ['jds-text', 'children-slot']
  },
  base: {
    container: {
      hidden: false,
      'background-color': '{l_0}',
      'flex-direction': '{l_1}',
      'justify-content': '{l_2}',
      'align-items': '{l_3}',
      behavior: {
        hover: {},
        visited: {},
        active: {},
        focus: {
          'border-radius': '{l_4}',
          'border-width': '{l_5}',
          'border-color': '{l_6}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_137}',
      color: '{text_13}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'text-color': 'primary_grey_60'
    }
  },
  variant: {
    _hasText: {
      false: {
        'jds-text': {
          hidden: true
        }
      }
    },
    _hasChildren: {
      false: {
        'children-slot': {
          hidden: true
        }
      },
      true: {
        'jds-text': {
          hidden: true
        }
      }
    },
    textAppearance: {
      body_s: {
        'jds-text': {
          'font-family': '{text_132}',
          'font-size': '{text_131}',
          'line-height': '{text_133}',
          'letter-spacing': '{text_134}',
          'font-weight': '{text_135}'
        }
      },
      body_s_bold: {
        'jds-text': {}
      },
      body_m: {
        'jds-text': {
          'font-family': '{text_117}',
          'font-size': '{text_116}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        }
      },
      body_m_bold: {
        'jds-text': {
          'font-family': '{text_122}',
          'font-size': '{text_121}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        }
      },
      body_l: {
        'jds-text': {
          'font-family': '{text_102}',
          'font-size': '{text_101}',
          'line-height': '{text_103}',
          'letter-spacing': '{text_104}',
          'font-weight': '{text_105}'
        }
      },
      body_l_bold: {
        'jds-text': {
          'font-family': '{text_107}',
          'font-size': '{text_106}',
          'line-height': '{text_108}',
          'letter-spacing': '{text_109}',
          'font-weight': '{text_110}'
        }
      },
      body_l_link: {
        'jds-text': {
          'font-family': '{text_112}',
          color: '{text_0}',
          'font-size': '{text_111}',
          'line-height': '{text_113}',
          'letter-spacing': '{text_114}',
          'font-weight': '{text_115}'
        }
      },
      body_xs: {
        'jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      },
      body_xxs: {
        'jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        }
      },
      body_s_link: {
        'jds-text': {
          'font-family': '{text_142}',
          color: '{text_0}',
          'font-size': '{text_141}',
          'line-height': '{text_143}',
          'letter-spacing': '{text_144}',
          'font-weight': '{text_145}'
        }
      },
      body_m_link: {
        'jds-text': {
          'font-family': '{text_127}',
          color: '{text_0}',
          'font-size': '{text_126}',
          'line-height': '{text_128}',
          'letter-spacing': '{text_129}',
          'font-weight': '{text_130}'
        }
      },
      body_xxs_link: {
        'jds-text': {
          'font-family': '{text_177}',
          color: '{text_0}',
          'font-size': '{text_176}',
          'line-height': '{text_178}',
          'letter-spacing': '{text_179}',
          'font-weight': '{text_180}'
        }
      },
      body_xs_link: {
        'jds-text': {
          'font-family': '{text_157}',
          color: '{text_0}',
          'font-size': '{text_156}',
          'line-height': '{text_158}',
          'letter-spacing': '{text_159}',
          'font-weight': '{text_160}'
        }
      },
      body_xs_bold: {
        'jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      body_xxs_bold: {
        'jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        }
      },
      heading_s: {
        'jds-text': {
          'font-family': '{text_81}',
          'font-size': '{text_80}',
          'line-height': '{text_82}',
          'letter-spacing': '{text_83}',
          'font-weight': '{text_84}'
        }
      },
      overline: {
        'jds-text': {
          'font-family': '{text_96}',
          'font-size': '{text_95}',
          'line-height': '{text_97}',
          'letter-spacing': '{text_98}',
          'font-weight': '{text_99}',
          'text-transform': '{text_100}'
        }
      },
      heading_xs: {
        'jds-text': {
          'font-family': '{text_86}',
          'font-size': '{text_85}',
          'line-height': '{text_87}',
          'letter-spacing': '{text_88}',
          'font-weight': '{text_89}'
        }
      },
      heading_xxs: {
        'jds-text': {
          'font-family': '{text_91}',
          'font-size': '{text_90}',
          'line-height': '{text_92}',
          'letter-spacing': '{text_93}',
          'font-weight': '{text_94}'
        }
      },
      heading_l: {
        'jds-text': {
          'font-family': '{text_71}',
          'font-size': '{text_70}',
          'line-height': '{text_72}',
          'letter-spacing': '{text_73}',
          'font-weight': '{text_74}'
        }
      },
      heading_m: {
        'jds-text': {
          'font-family': '{text_76}',
          'font-size': '{text_75}',
          'line-height': '{text_77}',
          'letter-spacing': '{text_78}',
          'font-weight': '{text_79}'
        }
      },
      heading_xl: {
        'jds-text': {
          'font-family': '{text_66}',
          'font-size': '{text_65}',
          'line-height': '{text_67}',
          'letter-spacing': '{text_68}',
          'font-weight': '{text_69}'
        }
      },
      list_title: {
        'jds-text': {
          'font-family': '{text_182}',
          'font-size': '{text_181}',
          'line-height': '{text_183}',
          'letter-spacing': '{text_184}',
          'font-weight': '{text_185}'
        }
      },
      button: {
        'jds-text': {
          'font-family': '{text_187}',
          'font-size': '{text_186}',
          'line-height': '{text_188}',
          'letter-spacing': '{text_189}',
          'font-weight': '{text_190}'
        }
      },
      code: {
        'jds-text': {
          'font-family': '{text_192}',
          'font-size': '{text_191}',
          'line-height': '{text_193}',
          'letter-spacing': '{text_194}',
          'font-weight': '{text_195}'
        }
      }
    },
    kind: {
      default: {
        'jds-text': {
          behavior: {
            hover: {
              color: '{text_14}'
            },
            visited: {
              color: '{text_21}'
            }
          }
        }
      },
      header: {
        container: {
          behavior: {
            focus: {
              'border-color': '{l_7}'
            }
          }
        },
        'jds-text': {
          color: '{text_18}',
          behavior: {
            hover: {
              'text-decoration': '{text_8}'
            }
          }
        }
      },
      submenu: {
        'jds-text': {
          color: '{text_21}',
          behavior: {
            hover: {
              color: '{text_20}',
              'text-decoration': '{text_8}'
            }
          }
        }
      },
      rich_text: {
        'jds-text': {
          color: '{text_20}',
          'text-decoration': '{text_8}',
          behavior: {
            hover: {
              'text-decoration': '{text_7}'
            }
          }
        }
      }
    }
  },
  combination: [
    {
      true: {
        header: {
          'jds-text': {
            'text-decoration': '{text_8}'
          }
        }
      }
    },
    {
      header: {
        none: {
          'jds-text': {
            color: '{text_18}',
            behavior: {
              hover: {
                'font-family': '{text_142}',
                color: '{text_0}',
                'font-size': '{text_141}',
                'line-height': '{text_143}',
                'letter-spacing': '{text_144}',
                'font-weight': '{text_145}'
              },
              active: {
                'font-family': '{text_142}',
                color: '{text_0}',
                'font-size': '{text_141}',
                'line-height': '{text_143}',
                'letter-spacing': '{text_144}',
                'font-weight': '{text_145}'
              }
            }
          }
        }
      },
      submenu: {
        none: {
          'jds-text': {}
        }
      },
      rich_text: {
        none: {
          'jds-text': {
            'font-family': '{text_142}',
            color: '{text_0}',
            'font-size': '{text_141}',
            'line-height': '{text_143}',
            'letter-spacing': '{text_144}',
            'font-weight': '{text_145}',
            behavior: {
              hover: {
                'font-family': '{text_137}',
                color: '{text_20}',
                'font-size': '{text_136}',
                'line-height': '{text_138}',
                'letter-spacing': '{text_139}',
                'font-weight': '{text_140}',
                'text-decoration': '{text_8}'
              }
            }
          }
        }
      },
      default: {
        none: {
          'jds-text': {
            behavior: {
              hover: {
                'font-family': '{text_142}',
                color: '{text_0}',
                'font-size': '{text_141}',
                'line-height': '{text_143}',
                'letter-spacing': '{text_144}',
                'font-weight': '{text_145}'
              }
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['_active', 'kind'],
    ['kind', 'textAppearance']
  ],
  api: {
    data: {
      container: {
        href: {
          type: 'string',
          name: 'href',
          doc_description: 'User provided href of the Link.'
        },
        target: {
          type: 'boolean',
          name: 'newTab',
          platform: 'web'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'title',
          doc_description: 'It displayes the title of Link.'
        }
      }
    },
    config: {
      _hasText: {
        values: [true, false]
      },
      _active: {
        values: [false, true]
      },
      _hasChildren: {
        values: [true, false]
      },
      textAppearance: {
        type: 'JDSText.appearance',
        doc_description:
          'It can be used to apply certain style to the title of the link.',
        values: [
          'body_s',
          'heading_xl',
          'heading_l',
          'heading_m',
          'heading_s',
          'heading_xs',
          'heading_xxs',
          'overline',
          'body_l',
          'body_l_bold',
          'body_l_link',
          'body_m',
          'body_m_bold',
          'body_m_link',
          'body_s_bold',
          'body_s_link',
          'body_xs',
          'body_xs_bold',
          'body_xs_link',
          'body_xxs',
          'body_xxs_bold',
          'body_xxs_link',
          'list_title',
          'button',
          'code',
          'body_xs_caps',
          'body_s_regular_para'
        ]
      },
      kind: {
        values: ['default', 'header', 'submenu', 'rich_text'],
        doc_description: 'It can be used to switch between 4 variants of Link.'
      }
    },
    events: {
      container: {
        onClick: 'onClick',
        onHover: {
          name: 'onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: 'onHoverEnd',
          platform: 'web'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any']
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'link'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'title'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
